import { render, staticRenderFns } from "./ResultLayer.vue?vue&type=template&id=8e87845e&scoped=true&"
import script from "./ResultLayer.vue?vue&type=script&lang=js&"
export * from "./ResultLayer.vue?vue&type=script&lang=js&"
import style0 from "./ResultLayer.vue?vue&type=style&index=0&id=8e87845e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e87845e",
  null
  
)

export default component.exports